import { Directive } from "@app/components/directive";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";

@NgComponent({
    token: Token.KbUiObject,
})
export class KbUiObject extends Directive {
    constructor() {
        super();

        this.replace = true;
        this.restrict = "E";
        this.scope = false;
        this.template = Dirs.component("kb-ui-object");

    }
}
